import React from 'react';
import PropTypes from 'prop-types';

const ErrorPage = ({ errorMessage, errorInfo }) => {
	return (
		<>
			<h2>An Error Has Occurred</h2>
			<details>
				<h2>{errorMessage}</h2>
				<h3>{errorInfo?.componentStack}</h3>
			</details>
		</>
	);
};

ErrorPage.propTypes = {
	errorMessage: PropTypes.string,
	errorInfo: PropTypes.object,
};

export default ErrorPage;
